
import clientAxios from "../client";

import { formatQueryString } from "@/common/utils/common";

import type { QueryType } from "@/common/types/common";
import type {
    CollectionRegionType,
    CollectionRegionPayloadType,
} from "@/common/types/collection-region";

export async function collectionRegionList(
    collection_id: string,
    query?: QueryType
) {
    const queryString = formatQueryString(query);

    return await clientAxios.get(
        `collection/${collection_id}/region/list${queryString}`
    );
}

export async function collectionRegionGet(
    item_id: string
) {
    return await clientAxios.get(
        `collection/region/${item_id}/show`
    );
}

export async function collectionRegionCreate(
    collection_id: string,
    payload: CollectionRegionPayloadType
) {
    return await clientAxios.post(
        `collection/${collection_id}/region/create`,
        payload
    );
}

export async function collectionRegionPatch(
    item_id: string,
    payload: Partial<CollectionRegionType>
) {
    return await clientAxios.patch(
        `collection/region/${item_id}/patch`,
        { payload }
    );
}

export async function collectionRegionDel(
    item_id: string,
) {
    return await clientAxios.del(
        `collection/region/${item_id}/delete`,
    );
}
